// import React from "react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

// export const Pagination = ({
//     page,
//     totalPages,
//     limit,
//     totalUsers,
//     setPage,
//     setLimit,
// }) => {
//     return (
//         <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 px-4 py-3 bg-blue-50 rounded-lg shadow">
//             {/* LEFT → Rows */}
//             <div className="flex items-center gap-2 text-sm text-gray-600">
//                 <span>Rows:</span>
//                 <select
//                     value={limit}
//                     onChange={(e) => {
//                         setLimit(Number(e.target.value));
//                         setPage(1);
//                     }}
//                     className="border rounded-md px-3 py-1 focus:ring-2 focus:ring-blue-400 outline-none"
//                 >
//                     <option value={10}>10</option>
//                     <option value={20}>20</option>
//                     <option value={50}>50</option>
//                     <option value={100}>100</option>
//                 </select>
//             </div>
//             {/* CENTER → Pagination */}
//             <div className="flex items-center gap-3 text-sm font-medium text-gray-700">

//                 <button
//                     disabled={page === 1}
//                     onClick={() => setPage(page - 1)}
//                     className="px-2 py-1 rounded border hover:bg-gray-100 disabled:opacity-40"
//                 >
//                     <FaChevronLeft />
//                 </button>

//                 <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-md">
//                     {page} / {totalPages}
//                 </span>

//                 <button
//                     disabled={page === totalPages}
//                     onClick={() => setPage(page + 1)}
//                     className="px-2 py-1 rounded border hover:bg-gray-100 disabled:opacity-40"
//                 >
//                     <FaChevronRight />
//                 </button>

//             </div>

//             {/* RIGHT → Total */}
//             <div className="text-sm text-gray-600 font-medium">

//                 Total: <span className="text-gray-800">{totalUsers}</span>

//             </div>

//         </div>

//     );
// };







import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

export const Pagination = ({
    page,
    totalPages,
    limit,
    totalUsers,
    setPage,
    setLimit,
}) => {

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 px-4 py-3 bg-blue-50 rounded-lg shadow">

            <div className="flex items-center gap-2 text-sm text-gray-600">
                <span>Rows:</span>

                <select
                    value={limit}
                    onChange={(e) => setLimit(Number(e.target.value))}
                    className="border rounded-md px-3 py-1 focus:ring-2 focus:ring-blue-400 outline-none"
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>

            </div>

            <div className="flex items-center gap-3 text-sm font-medium text-gray-700">

                <button
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                    className="px-2 py-1 rounded border hover:bg-gray-100 disabled:opacity-40"
                >
                    <FaChevronLeft />
                </button>

                <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-md">
                    {page} / {totalPages}
                </span>

                <button
                    disabled={page === totalPages}
                    onClick={() => setPage(page + 1)}
                    className="px-2 py-1 rounded border hover:bg-gray-100 disabled:opacity-40"
                >
                    <FaChevronRight />
                </button>

            </div>

            <div className="text-sm text-gray-600 font-medium">
                Total: <span className="text-gray-800">{totalUsers}</span>
            </div>

        </div>
    );
};